export default {
  MuiSwitch: {
    styleOverrides: {
      root: {
        width: 65,
        height: 30,
        padding: '4px 10px'
      },
      switchBase: {
        left: '0.5px',
        padding: '1px 1px 1px 1px',
        transform: 'translate(10px, 4.55px)',
        '&.Mui-checked': {
          transform: 'translate(32px, 4.55px)',
          color: 'white',
          '& + .MuiSwitch-track': {
            backgroundColor: '#59b960',
            opacity: 1,
            border: 'none'
          }
        }
      },
      thumb: {
        width: 18,
        height: 18,
        boxShadow: 'none'
      },
      track: {
        borderRadius: 80,
        border: `1px solid #b20000`,
        backgroundColor: '#b20000',
        opacity: 1
      },
      checked: {}
    }
  }
};
